import { Form } from 'react-bootstrap';
import './row-checkbox.component.scss';
interface RowCheckboxComponentProps {
  selectRowHandler(row: Record<string, any>, checked?: boolean): void;
  isCheckedCallback(row?: Record<string, any>): boolean | undefined;
  data: Record<string, any>;
  excludeMode?: boolean;
  isLastLevel: boolean;
}
export const RowCheckboxComponent = ({
  data,
  selectRowHandler,
  isCheckedCallback,
  isLastLevel,
}: RowCheckboxComponentProps) => {
  return (
    <Form.Check
      className="compactoggleswitch"
      key={Math.random()}
      type={isLastLevel ? 'checkbox' : 'switch'}
      label=""
      checked={isCheckedCallback(data)}
      onChange={(e) => selectRowHandler(data, e?.currentTarget?.checked)}
    />
  );
};
